import React from 'react'
import PropTypes from 'prop-types'
import {
 ControlledModal, Button, Link, Typography 
} from '@telus/koodo-ui-kit'
import { isMobile } from 'react-device-detect'

/**
 * AlreadyActivatedModal — shown when retrieveAccountByEmail returns a role
 * indicating the email is already fully activated (no in-progress quote,
 * no deactivated state).
 */
const AlreadyActivatedModal = ({
    isOpen,
    onGoToPortal,
    onUseOtherEmail,
    title,
    bodyText,
    goToPortalLabel,
    useOtherEmailLabel
}) => (
    <ControlledModal
        isOpen={isOpen}
        onClose={onUseOtherEmail}
        title={title}
        testId="already-activated-modal"
        maxWidth={isMobile ? '100%' : '800px'}
        actions={
            <>
                <Button
                    onPress={onGoToPortal}
                    variant={{ priority: 'high' }}
                    testId="go-to-portal"
                >
                    {goToPortalLabel}
                </Button>
                <div className="flex items-center">
                    <Link
                        href="/"
                        onClick={(e) => { e.preventDefault(); onUseOtherEmail() }}
                        testId="use-other-email-modal"
                    >
                        {useOtherEmailLabel}
                    </Link>
                </div>
            </>
        }
    >
        <Typography variant={{ size: 'medium' }} block>
            {bodyText}
        </Typography>
    </ControlledModal>
)

AlreadyActivatedModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onGoToPortal: PropTypes.func.isRequired,
    onUseOtherEmail: PropTypes.func.isRequired,
    title: PropTypes.string,
    bodyText: PropTypes.string,
    goToPortalLabel: PropTypes.string,
    useOtherEmailLabel: PropTypes.string
}

AlreadyActivatedModal.defaultProps = {
    title: '',
    bodyText: '',
    goToPortalLabel: '',
    useOtherEmailLabel: ''
}

export default AlreadyActivatedModal
